import React from 'react';

import MainModal from 'shared/ui/Modal/MainModal';

export interface IAdminEntityModalProps<T> {
    open: boolean,
    handleClose: () => void,
    item?: T,
}

export interface IAdminEntityFormProps<T> {
    item?: T,
    onSuccess: () => void,
    onClose: () => void,
}

interface IAdminFormModalProps<T> extends IAdminEntityModalProps<T> {
    addHeader: string,
    editHeader: string,
    Form: React.ComponentType<IAdminEntityFormProps<T>>,
}

const AdminFormModal = <T, >({open, handleClose, item, addHeader, editHeader, Form}: IAdminFormModalProps<T>) => (
    <MainModal
        header={item ? editHeader : addHeader}
        open={open}
        handleClose={handleClose}
        size="md"
    >
        <Form item={item} onSuccess={handleClose} onClose={handleClose}/>
    </MainModal>
);

export default AdminFormModal;
